<template>
	<div ref="popupContainer">
		<FilterCard
			:refreshKey="1"
			:key="filterRefreshKey"
			:isOpen="true"
			:showListLength="notificationList.length"
			:filters="filtersTemplates"
			@filter="handleFilterEmits($event)"
			:actions="actionsTemplates"
			@action="handleActionEmits($event)"
			:onChangeEmit="true"
			@clearAll="resetAllFilter()"
		/>
		<div v-if="isLoading" class="flex center">
			<CircularLoader />
		</div>
		<vs-table v-else :data="displayedNotification">
			<template slot="thead">
				<vs-th class="th-sticky pdl0">CLIENT</vs-th>
				<vs-th class="th-sticky pdl0">PRESATATION</vs-th>
				<vs-th class="th-sticky pdl0">Contrat N°</vs-th>
				<vs-th class="th-sticky pdl0">Consultant Lead</vs-th>
				<vs-th class="th-sticky pdl0">BUDGET</vs-th>
				<vs-th class="th-sticky pdl0">Période</vs-th>
				<vs-th class="th-sticky pdl0">Action</vs-th>
			</template>
			<template slot-scope="{ data }">
				<vs-tr :key="index" v-for="(row, index) in data">
					<vs-td :data="row.contract_society_id"
						><span
							class="hvr-underline"
							@click="displaySocietyPopup(row.contract_society_id)"
							><strong>{{ row.society_name }}</strong></span
						></vs-td
					>
					<vs-td>{{ row.perform }}</vs-td>
					<vs-td
						><span
							@click="displayContractPopup(row.contract_id)"
							class="hvr-underline hvr-underline-out"
							>{{ row.contract_id }}</span
						></vs-td
					>
					<vs-td v-if="row.consultant_name" class="pdl0">
						<div class="flex center" style="justify-content: center">
							<vx-tooltip :text="row.consultant_name" position="top">
								<vs-avatar
									style="border: 1px solid"
									:text="row.consultant_name"
									:src="getCollaboratorAvatar(row.flex_user_id)"
								/>
							</vx-tooltip>
						</div>
					</vs-td>
					<vs-td>
						{{ row.price }}
					</vs-td>
					<vs-td>
						{{ getMonth(row.flex_start_date) }}
					</vs-td>
					<vs-td>
						<vs-button
							v-if="row.flex_is_check == 1"
							color="success"
							@click="displayFlexibleMissionDivisionPopup(row)"
							><vs-icon
								:icon="row.is_editable ? 'edit' : 'visibility'"
								size="medium"
						/></vs-button>
						<vs-button
							v-else
							color="warning"
							@click="displayFlexibleMissionDivisionPopup(row)"
							><vs-icon icon="error" size="medium"
						/></vs-button>
					</vs-td>
				</vs-tr>
			</template>
		</vs-table>
	</div>
</template>

<script>
import Vue from "vue";
import VueCookies from "vue-cookies";
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import utilsMixin from "@/mixins/utilsMixin";
import store from "@/store/store";
import FilterCard from "@/views/filters/FilterCard.vue";
import flatPickr from "vue-flatpickr-component";
import moment from "moment";
import "flatpickr/dist/flatpickr.css";
import monthSelect from "flatpickr/dist/plugins/monthSelect";
import "flatpickr/dist/plugins/monthSelect/style.css";
import ContractInfoPopup from "@/components/popups/ContractInfoPopup";
import FlexibleMissionDivisionPopup from "@/components/popups/FlexibleMissionDivisionPopup";
import SocietyInfoPopup from "@/components/popups/SocietyInfoPopup";
import CircularLoader from "../widgets/loader/CircularLoader.vue";
import FlexibleMission from "../../entities/FlexibleMission";

export default {
	name: "FlexibleMissionTable",
	components: {
		flatPickr,
		ContractInfoPopup,
		SocietyInfoPopup,
		monthSelect,
		FilterCard,
		FlexibleMissionDivisionPopup,
		CircularLoader,
	},
	props: {
		allNotifications: Array,
		sortUserId: Boolean,
		allSocieties: Array,
		allCollaborators: Array,
		allCollaboratorsAvatar: Array,
	},
	mixins: [dbFieldConvertor, utilsMixin],
	computed: {
		// allFlexibleMissions: () => {
		// 	return store.state.flexibleMissions.reverse();
		// },
		relanceFilter: () => {
			return store.state.relanceFilter;
		},
		notifications: () => {
			return store.state.notifications;
		},
		notifications_types: () => {
			return store.state.notifications_types;
		},
		activeUser: () => {
			return VueCookies.get("userInfo");
		},
		allContractsWithContractsUsers: () => {
			return store.state.contracts_contracts_users;
		},
		societies: () => {
			return store.state.societies;
		},
		filterType: () => {
			return store.state.relanceFilter;
		},
	},
	data() {
		return {
			apiUrl: store.state.backendApiUrl,
			list: [],
			displayedNotification: [],
			displayNotificationsFull: [],
			notificationList: [],
			resetFilter: null,
			// commercialFilter: null,
			accountmanagerFilter: "",
			contractNumberFilter: null,
			societyFilter: null,
			budgetFilter: null,
			// typeFilter: [],
			showContractPopup: false,
			statusFilter: "0",
			dateFilter: null,
			dateFilterOn: false,
			accountmanagerFilterOn: false,
			budgetFilterOn: false,
			// commercialFilterOn: false,
			// deliveryFilterOn: false,
			societyFilterOn: false,
			statusFilterOn: false,
			// typeFilterOn: false,
			contractNumberFilterOn: false,
			collabList: [],
			filterRefreshKey: 0,
			notificationStatus: [
				{
					text: "A traiter",
					id: "0",
				},
				{
					text: "Traitée",
					id: "1",
				},
			],
			configDatePicker: {
				locale: require("flatpickr/dist/l10n/fr.js").default.fr,
				plugins: [
					new monthSelect({
						shorthand: true,
						dateFormat: "m/Y",
						altFormat: "m-Y",
						theme: "light",
					}),
				],
			},
			refreshKey: 0,
			filtersTemplates: [
				{
					order: 1, // Filter order compared to others
					emitSlugName: "filter_contract",
					filterPlaceHolder: "N° de Contrat",
					value: "", // Consultant id
					type: "Input",
				},
				{
					order: 2,
					emitSlugName: "filter_client",
					filterPlaceHolder: "Client",
					value: "",
					type: "Input",
				},
				{
					order: 2,
					emitSlugName: "filter_budget",
					filterPlaceHolder: "Budget",
					value: "",
					type: "Input",
				},

				{
					order: 3,
					emitSlugName: "filter_status",
					filterPlaceHolder: "Statut",
					value: "",
					type: "Dropdown",
					params: {
						autocomplete: true,
						dropdownValues: [
							{ name: "A traiter", id: 1 },
							{ name: "Traitée", id: 2 },
						],
					},
				},
				{
					order: 4,
					emitSlugName: "filter_period",
					filterPlaceHolder: "Période",
					value: "",
					require: true,
					type: "Date",
					params: {
						date_type: "period",
					},
				},
				// {
				// 	order: 4,
				// 	emitSlugName: "filter_type",
				// 	filterPlaceHolder: "Type",
				// 	value: "",
				// 	type: "Dropdown",
				// 	params: {
				// 		autocomplete: true,
				// 		dropdownValues: [
				// 		// {name: "Mensuel", id: 1},
				// 		// 	{name: "One Shot", id: 0}
				// 			//add one to avoid collision of value 0 with defaut

				// 			{name: "Mensuel", id: 2},
				// 			{name: "One Shot", id: 1}
				// 		]
				// 	}
				// },
				//  {
				// 	order: 5,
				// 	emitSlugName: "filter_status",
				// 	filterPlaceHolder: "Statut (Sélection multiple)",
				// 	value: "",
				// 	type: "Dropdown",
				// 	params: {
				// 		autocomplete: true,
				// 		multiple: true,
				// 		dropdownValues: [
				// 			{name: "Actif", id: 1},
				// 			{name: "A\u00a0Valider", id: 2},
				// 			{name: "A\u00a0venir", id: 8},
				// 			{name: "En\u00a0pause", id: 3},
				// 			{name: "Terminé", id: 4},
				// 			{name: "Annulé", id: 5},
				// 			{name: "Relance", id: 9},
				// 		]
				// 	}
				// }, {
				// 	order: 6,
				// 	emitSlugName: "filter_commercial",
				// 	filterPlaceHolder: "Commercial",
				// 	value: "",
				// 	type: "Dropdown",
				// 	params: {
				// 		autocomplete: true,
				// 		multiple: false,
				// 		dropdownValues: []
				// 	}
				// },
				{
					order: 5,
					emitSlugName: "filter_consultant",
					filterPlaceHolder: "Consultant Lead",
					value: "1",
					type: "Dropdown",
					params: {
						autocomplete: true,
						multiple: false,
						dropdownValues: [],
					},
				},
			],
		};
	},
	async created() {
		this.isLoading = true;
		this.$store.dispatch("getAllContractsWithContractsUsers");
		this.$store.dispatch("getAllSocieties");
		await this.fetchFlexibleMissions();

		/*
		 * let today = new Date(Date.now());
		 *  IF ACTIVE USER ID IS IN COMMERCIAL FILTER LIST SELECT
		 */
		//let foundCollaborator = this.allCollaborators.findIndex(row => row.id == this.activeUser.id);
		this.commercialFilter = this.relanceFilter.commercialFilter;
		this.endDateFilter = this.relanceFilter.endDateFilter;
		this.startDateFilter = this.relanceFilter.startDateFilter;
		this.typeFilter = this.relanceFilter.startDateFilter;
		this.statusFilter = this.relanceFilter.statusFilter;
		this.notificationList = this.allFlexibleMissions;
		this.displayedNotification = this.notificationList;
		this.displayNotificationsFull = this.displayedNotification;
		this.collabList = this.$props.allCollaborators;
		this.addCollabList();
		// making default dilter the consultant who use
		if (this.activeUser.id) {
			this.filtersTemplates[5].value = this.activeUser.id;
			this.accountmanagerFilter = this.activeUser.id;
		}
		this.filtersTemplates[4].value = moment().format("MM/YYYY");
		this.dateFilter = moment().format("MM/YYYY");
		this.isLoading = false;
		//this.notificationFilter(this.displayNotificationsFull);
	},
	updated() {
		this.$store.dispatch("setRowNum", this.displayedNotification.length);
	},
	watch: {
		"$store.state.flexiblePopupContractId": function (contractId) {
			if (contractId) {
				// Pre-fill the contract filter when popup opens with a contract_id
				let contractFilterIndex = this.filtersTemplates.findIndex(
					(row) => row.emitSlugName === "filter_contract"
				);
				if (contractFilterIndex >= 0) {
					this.filtersTemplates[contractFilterIndex].value = contractId;
					this.contractNumberFilter = contractId;
				}
			}
		},
		"$store.state.flexiblePopupLeadConsultantId": function (consultantId) {
			if (consultantId) {
				// Pre-fill the consultant filter when popup opens with a consultant_id
				let consultantFilterIndex = this.filtersTemplates.findIndex(
					(row) => row.emitSlugName === "filter_consultant"
				);
				if (consultantFilterIndex >= 0) {
					this.filtersTemplates[consultantFilterIndex].value = consultantId;
					this.accountmanagerFilter = consultantId;
				}
			}
		},
		"$store.state.relanceFilter": async function (data) {
			this.commercialFilter = data.commercialFilter;
		},
		"$props.allNotifications": function (data) {
			this.notificationList = data;
			this.displayedNotification = this.notificationList;
			this.displayNotificationsFull = this.displayedNotification;
		},
		// '$props.allCollaborators': function(data){
		// 	let foundCommercialFilterId = this.filtersTemplates.findIndex(row => row.emitSlugName == "filter_commercial");
		// 	if(foundCommercialFilterId){
		// 		this.filtersTemplates[foundCommercialFilterId].params.dropdownValues = data.filter(collaborator => [4, 6, 9].includes(collaborator.type)).sort((a, b) => {
		// 			return (a["firstname"]).localeCompare(b["firstname"]); //using String.prototype.localCompare()
		// 		}).map(row => {
		// 			return {id: row.id, name: row.firstname + " " + row.lastname};
		// 		});
		// 	}
		// 	let foundConsultantFilterId = this.filtersTemplates.findIndex(row => row.emitSlugName == "filter_consultant");
		// 	if(foundConsultantFilterId){
		// 		this.filtersTemplates[foundConsultantFilterId].params.dropdownValues = data.filter(collaborator => [3, 6, 7, 9].includes(collaborator.type)).sort((a, b) => {
		// 			return (a["firstname"]).localeCompare(b["firstname"]); //using String.prototype.localCompare()
		// 		}).map(row => {
		// 			return {id: row.id, name: row.firstname + " " + row.lastname};
		// 		});
		// 	}
		// 	/*
		// 	 * this.commercialOptions = this.sortABC(this.allCollaborators.filter(collaborator => [4, 6, 9].includes(collaborator.type)),"firstname");
		// 	 * this.accountmanagerOptions = this.sortABC(this.allCollaborators.filter(collaborator => [3, 6, 9].includes(collaborator.type)), "firstname");
		// 	 */
		// },
		accountmanagerFilter: function () {
			if (this.accountmanagerFilter == "") {
				this.accountmanagerFilterOn = false;
			} else {
				this.accountmanagerFilterOn = true;
			}
			this.refreshKey++;
			this.displayedNotification = this.filterNotification(
				this.displayNotificationsFull
			);
		},
		commercialFilter: function () {
			if (this.commercialFilter == "") {
				this.commercialFilterOn = false;
			} else {
				this.commercialFilterOn = true;
			}
			this.refreshKey++;
			this.displayedNotification = this.filterNotification(
				this.displayNotificationsFull
			);
		},
		deliveryFilter: function () {
			if (this.deliveryFilter == "") {
				this.deliveryFilterOn = false;
			} else {
				this.deliveryFilterOn = true;
			}
			this.refreshKey++;
			this.displayedNotification = this.filterNotification(
				this.displayNotificationsFull
			);
		},
		societyFilter: function () {
			if (this.societyFilter == "") {
				this.societyFilterOn = false;
			} else {
				this.societyFilterOn = true;
			}
			this.refreshKey++;
			this.displayedNotification = this.filterNotification(
				this.displayNotificationsFull
			);
		},
		contractNumberFilter: function () {
			if (this.contractNumberFilter == "") {
				this.contractNumberFilterOn = false;
			} else {
				this.contractNumberFilterOn = true;
			}
			this.refreshKey++;
			this.displayedNotification = this.filterNotification(
				this.displayNotificationsFull
			);
		},
		statusFilter: function () {
			if (this.statusFilter == "") {
				this.statusFilterOn = false;
			} else {
				this.statusFilterOn = true;
			}
			this.refreshKey++;
			this.displayedNotification = this.filterNotification(
				this.displayNotificationsFull
			);
		},
		dateFilter: function (data) {
			if (this.dateFilter == null) {
				this.dateFilterOn = false;
			} else {
				this.dateFilterOn = true;
			}
			this.refreshKey++;
			this.displayedNotification = this.filterNotification(
				this.displayNotificationsFull
			);
		},
		typeFilter: function () {
			if (this.typeFilter == "") {
				this.typeFilterOn = false;
			} else {
				this.typeFilterOn = true;
			}
			this.refreshKey++;
			this.displayedNotification = this.filterNotification(
				this.displayNotificationsFull
			);
		},
		budgetFilter: function () {
			if (this.budgetFilter == "") {
				this.budgetFilterOn = false;
			} else {
				this.budgetFilterOn = true;
			}
			this.refreshKey++;
			this.displayedNotification = this.filterNotification(
				this.displayNotificationsFull
			);
		},
		/*
		 * this.commercialOptions = this.sortABC(this.allCollaborators.filter(collaborator => [4, 6, 9].includes(collaborator.type)),"firstname");
		 * this.accountmanagerOptions = this.sortABC(this.allCollaborators.filter(collaborator => [3, 6, 9].includes(collaborator.type)), "firstname");
		 */
	},
	methods: {
		async fetchFlexibleMissions() {
			this.allFlexibleMissions = await FlexibleMission.getAll();
		},
		resetAllFilter() {
			this.accountmanagerFilter = "";
			this.commercialFilter = "";
			this.deliveryFilter = "";
			this.societyFilter = "";
			this.statusFilter = [];
			this.typeFilter = "";
			this.budgetFilter = "";
			this.dateFilter = "";
			this.contractNumberFilter = "";
			this.dateFilterOn = false;
			this.accountmanagerFilterOn = false;
			this.commercialFilterOn = false;
			this.deliveryFilterOn = false;
			this.societyFilterOn = false;
			this.statusFilterOn = false;
			this.typeFilterOn = false;
			this.budgetFilterOn = false;
			this.contractNumberFilterOn = false;
			this.filterNotification(this.displayNotificationsFull);
		},
		getMonth(date) {
			let str = moment(date).locale("FR").format("MMMM YYYY");
			return str.charAt(0).toUpperCase() + str.slice(1);
		},
		/**
		 * @method handleFilterEmits Receives filter emits and assign filters accordingly
		 * @param {Array} receivedEmit First cell is the filter's slug, second cell is the filter value
		 */
		handleFilterEmits(receivedEmit) {
			//console.log(receivedEmit);
			// Find template value
			let templateRowIndex = this.filtersTemplates.findIndex(
				(row) => row.emitSlugName == receivedEmit[0]
			);
			if (templateRowIndex >= 0)
				this.filtersTemplates[templateRowIndex].value = receivedEmit[1].value;
			switch (receivedEmit[0]) {
				case "filter_client":
					this.societyFilter = receivedEmit[1].value;
					break;
				case "filter_contract":
					this.contractNumberFilter = receivedEmit[1].value;
					break;
				case "filter_delivery":
					this.deliveryFilter = receivedEmit[1].value;
					break;
				case "filter_type":
					this.typeFilter = receivedEmit[1].value;
					break;
				case "filter_period":
					this.dateFilter = receivedEmit[1].value;
					break;
				case "filter_status":
					this.statusFilter = receivedEmit[1].value;
					break;
				case "filter_commercial":
					this.commercialFilter = receivedEmit[1].value;
					break;
				case "filter_consultant":
					this.accountmanagerFilter = receivedEmit[1].value;
					break;
				case "filter_budget":
					this.budgetFilter = receivedEmit[1].value;
					break;
				default:
					break;
			}
			/*
			 * Find filter value
			 * switch(receivedEmit[0]){
			 * 	case "filter"
			 * }
			 */
		},
		/**
		 * Return list of filtered netlink A CHANGER
		 * @param {String} deliveryFilter - Type of delivery
		 * @param {String} societyFilter - String to match in society name
		 * @param {String} contractNumberFilter - Contract Id filter
		 * @param {String} statusFilter - Contract status filter
		 * @return {List} - Societies' list filtered
		 */
		filterNotification(contract) {
			//console.log("filterProviders BEGIN", contract);
			let contractList = [];
			let searchKeyList = {};

			if (this.statusFilterOn) {
				searchKeyList["statusFilter"] = Number(this.statusFilter) - 1;
			}
			if (this.deliveryFilterOn) {
				searchKeyList["deliveryFilter"] = this.deliveryFilter;
				//console.log("f" + searchKeyList["deliveryFilter"]);
			}

			this.dateFilterOn
				? (searchKeyList["dateFilter"] = this.dateFilter)
				: false;
			this.accountmanagerFilterOn
				? (searchKeyList["accountmanagerFilter"] = this.accountmanagerFilter)
				: false;
			this.commercialFilterOn
				? (searchKeyList["commercialFilter"] = this.commercialFilter)
				: false;
			this.societyFilterOn
				? (searchKeyList["societyFilter"] = this.societyFilter
						.toLowerCase()
						.normalize("NFD")
						.replace(/[\u0300-\u036f]/g, ""))
				: false;
			this.typeFilterOn
				? (searchKeyList["typeFilter"] = parseInt(this.typeFilter) - 1)
				: false; //minus one to avoid collision of value 0 with defaut
			this.contractNumberFilterOn
				? (searchKeyList["contractNumberFilter"] = this.contractNumberFilter)
				: false;
			this.budgetFilterOn
				? (searchKeyList["budgetFilter"] = this.budgetFilter)
				: false;

			for (let contractToFilter of contract) {
				////console.log(netlinkToFilter)
				let society_name = contractToFilter.society_name;

				if (society_name) society_name = society_name.toLowerCase();

				let contractSearchKeyList = {};
				if (this.accountmanagerFilterOn) {
					if (contractToFilter.account_managers) {
						contractSearchKeyList["accountmanagerFilter"] =
							contractToFilter.account_managers.split(", ");
					}
				}
				this.dateFilterOn
					? (contractSearchKeyList["dateFilter"] = moment(
							contractToFilter.flex_start_date
					  ).format("MM/YYYY"))
					: false;
				this.accountmanagerFilterOn
					? (contractSearchKeyList["accountmanagerFilter"] =
							contractToFilter.flex_user_id)
					: false;
				this.commercialFilterOn
					? (contractSearchKeyList["commercialFilter"] =
							contractToFilter.commercial_id)
					: false;
				this.societyFilterOn
					? (contractSearchKeyList["societyFilter"] = society_name
							.toString()
							.normalize("NFD")
							.replace(/[\u0300-\u036f]/g, ""))
					: false;
				this.deliveryFilterOn
					? (contractSearchKeyList["deliveryFilter"] =
							contractToFilter.delivery)
					: false;
				this.contractNumberFilterOn
					? (contractSearchKeyList["contractNumberFilter"] =
							contractToFilter.contract_id.toString())
					: false;
				// this.typeFilterOn ? contractSearchKeyList["typeFilter"] = contractToFilter.type : false;
				this.statusFilterOn
					? (contractSearchKeyList["statusFilter"] =
							contractToFilter.flex_is_check)
					: false;
				this.budgetFilterOn
					? (contractSearchKeyList["budgetFilter"] =
							contractToFilter.price.toString())
					: false;

				let check = true;

				for (let key in searchKeyList) {
					/*
					 * //console.log("TYPE")
					 * //console.log(typeof contractSearchKeyList[key])
					 */
					if (typeof searchKeyList[key] == "string") {
						if (typeof contractSearchKeyList[key] == "string") {
							if (!contractSearchKeyList[key].includes(searchKeyList[key])) {
								check = false;
								break;
							}
						} else if (typeof contractSearchKeyList[key] == "object") {
							////console.log("Array")
							let checkLoop = false;
							for (let value of contractSearchKeyList[key]) {
								let service_name = this.getServiceIdToName(value).toLowerCase();
								/*
								 * //console.log(service_name)
								 * //console.log(searchKeyList[key])
								 */
								if (service_name.includes(searchKeyList[key])) {
									////console.log("checkLoop = true;")
									checkLoop = true;
								}
							}
							if (!checkLoop) {
								check = checkLoop;
								break;
							}
						}
					} else {
						if (Array.isArray(contractSearchKeyList[key])) {
							// //console.log("contractSearchKeyList[key]",contractSearchKeyList[key])
							let searchKey = searchKeyList[key];
							// //console.log(searchKey)
							let stringSearchKey = searchKey.toString();
							if (!contractSearchKeyList[key].includes(stringSearchKey)) {
								check = false;
								break;
							}
						} else {
							if (Array.isArray(searchKeyList[key])) {
								let searchKey = searchKeyList[key].map((value) => value);
								if (!searchKey.includes(contractSearchKeyList[key])) {
									check = false;
									break;
								}
							} else {
								let searchKey = searchKeyList[key];
								if (contractSearchKeyList[key] != searchKey) {
									check = false;
									break;
								}
							}
						}
					}
				}

				if (check) contractList.push(contractToFilter);
			}
			/*
			 * return result
			 * //console.log("filterProviders END")
			 */
			return contractList;
		},
		addCollabList() {
			let foundConsultantFilterId = this.filtersTemplates.findIndex(
				(row) => row.emitSlugName == "filter_consultant"
			);
			if (foundConsultantFilterId) {
				this.filtersTemplates[foundConsultantFilterId].params.dropdownValues =
					this.collabList
						.filter((collaborator) => [3, 6, 7, 9].includes(collaborator.type))
						.sort((a, b) => {
							return a["firstname"].localeCompare(b["firstname"]); //using String.prototype.localCompare()
						})
						.map((row) => {
							return { id: row.id, name: row.firstname + " " + row.lastname };
						});
			}
			this.filterRefreshKey++;
		},
		/**
		 * Show contract popup
		 */
		displayContractPopup(contract_id) {
			let selectedContract = null;
			let foundContract = this.allContractsWithContractsUsers.findIndex(
				(row) => row.id == contract_id
			);
			if (foundContract < 0) {
				this.$vs.notify({
					title: "Erreur",
					text: "Contrat introuvable, contactez l'équipe technique.",
				});
				return false;
			}
			let account_manager_avatars = [];
			if (this.allContractsWithContractsUsers[foundContract].account_managers) {
				let contract_account_managers_names =
					this.allContractsWithContractsUsers[foundContract]
						.account_managers !== null
						? this.allContractsWithContractsUsers[
								foundContract
						  ].account_managers.split(", ")
						: [];
				let contract_account_managers = contract_account_managers_names.splice(
					0,
					contract_account_managers_names.length / 2
				);
				for (let i = 0; i < contract_account_managers.length; i++) {
					account_manager_avatars.push({
						name: contract_account_managers_names[i],
						users_id: contract_account_managers[i],
						is_lead:
							this.allContractsWithContractsUsers[foundContract].lead_am ==
							contract_account_managers[i]
								? 1
								: 0,
					});
				}
			}
			selectedContract = this.allContractsWithContractsUsers[foundContract];
			selectedContract.account_manager_avatars = account_manager_avatars;
			this.showContractPopup = true;

			//Instancie la class SocietyInfoPopup pour mount sur la balise div principale
			let ComponentClass = Vue.extend(ContractInfoPopup);
			let contractPopup = new ComponentClass({
				propsData: {
					contract: selectedContract,
					popupActive: this.showContractPopup,
					router: this.$router,
				},
			});
			// @modify-contract="modifyContract($event)"
			contractPopup.$mount();
			contractPopup.$on("modify-contract", (contractId) => {
				this.modifyContract(contractId);
			});
			contractPopup.$on("modify-missions", (contractId) => {
				this.modifyMissions(contractId);
			});

			//this.$refs.popupContainer.appendChild(contractPopup.$el);
		},
		displayFlexibleMissionDivisionPopup(mission) {
			try {
				//Instancie la class SocietyInfoPopup pour mount sur la balise div principale
				let ComponentClass = Vue.extend(FlexibleMissionDivisionPopup);
				let contractPopup = new ComponentClass({
					propsData: {
						isPopupActive: true,
						mission: mission,
						thisPeriod: this.dateFilter || moment(mission.flex_creation_date).format("MM/YYYY"),
						isEdit: mission.flex_is_check == 1 ? true : false,
					},
				});
				// @modify-contract="modifyContract($event)"
				contractPopup.$mount();
				contractPopup.$on("modify-contract", (contractId) => {
					this.modifyContract(contractId);
				});
				contractPopup.$on("modify-missions", (contractId) => {
					this.modifyMissions(contractId);
				});

				this.$refs.popupContainer.appendChild(contractPopup.$el);
			} catch (e) {
				console.log(e);
			}
		},

		/**
		 * Show society popup
		 */
		displaySocietyPopup(societyId) {
			let selectedSociety = null; // Always reset data before assigning it
			selectedSociety = JSON.parse(
				JSON.stringify(
					this.societies.find((society) => society.id == societyId)
				)
			);
			this.$http
				.get(this.apiUrl + "society/getImg/" + societyId)
				.then((image) => {
					let imgObject = null;
					if (image.data.length > 0) {
						imgObject = image.data;
					}

					selectedSociety.image = imgObject;
				})
				.catch((err) => {
					//console.log(err);
				});

			//Instancie la class SocietyInfoPopup pour mount sur la balise div principale
			let ComponentClass = Vue.extend(SocietyInfoPopup);
			let societyPopup = new ComponentClass({
				propsData: {
					society: selectedSociety,
					popupActive: true,
					router: this.$router,
					apiUrl: this.apiUrl,
				},
			});
			societyPopup.$mount();
			this.$refs.popupContainer.appendChild(societyPopup.$el);
		},

		/**
		 * Jump to updateContract page
		
		/**
		 * Get a collaborator's name by @param {Number} userId - ID of this collaborator
		 * @return {String}
		 */
		getCollaboratorName(userId) {
			let foundCollaborator = this.allCollaborators.find(
				(collaborator) => collaborator.id == userId
			);
			if (foundCollaborator)
				return foundCollaborator.firstname + " " + foundCollaborator.lastname;
			else return null;
		},

		/**
		 * Get a collaborator's avatar by @param {Number} userId - ID of this collaborator
		 * @return {String}
		 */
		getCollaboratorAvatar(userId) {
			let foundAvatar = this.allCollaboratorsAvatar.find(
				(avatar) => avatar.id == userId
			);
			if (foundAvatar) return foundAvatar.avatar;
			else return null;
		},

		/**
		 * Get a society's name for a notification
		 * @param {Number} societyId - society's ID of this notification
		 * @return {String}
		 */
		getSocietyName(societyId) {
			if (
				this.$props.allSocieties.filter((society) => society.id == societyId)
					.length > 0
			) {
				return this.$props.allSocieties.filter(
					(society) => society.id == societyId
				)[0].name;
			}
			return "Entreprise non renseignée";
		},

		// /**
		//  * Get value of "input_required" for a notification
		//  * @param {Number} id - notification type ID of this notification
		//  * @return {Number}
		//  */
		// isInputRequired(id){
		// 	return this.notifications_types.filter(type => type.id == id)[0].input_required;
		// },

		// /**
		//  * Notification Filter
		//  */
		// async notificationFilter(){
		// 	let result = [...this.notifications];

		// 	this.commercialFilter = this.$store.state.relanceFilter.commercialFilter;
		// 	if(this.commercialFilter) result = result.filter(n => n.commercial_id == this.commercialFilter);
		// 	if(this.typeFilter.length > 0) result = result.filter(n => this.typeFilter.includes(n.notification_type_id));
		// 	if(this.societyFilter) {
		// 		let tmpSocieties = this.$props.allSocieties.filter(society => society.name.toLowerCase().includes(this.societyFilter.toLowerCase()));
		// 		if(tmpSocieties.length > 0) {
		// 			tmpSocieties = tmpSocieties.map((society) => {
		// 				return society.id;
		// 			});
		// 			result = result.filter(n => tmpSocieties.includes(n.society_id));
		// 		}
		// 	}
		// 	if(this.contractNumberFilter) result = result.filter(n => String(n.contract_id).includes(this.contractNumberFilter));
		// 	if(this.startDateFilter) result = result.filter(n => Number(n.estimated_end_date.substr(0, 7).replace("-", "")) >= Number(this.startDateFilter.split("/").reverse().join("")));
		// 	if(this.endDateFilter) result = result.filter(n => Number(n.estimated_end_date.substr(0, 7).replace("-", "")) <= Number(this.endDateFilter.split("/").reverse().join("")));
		// 	if(this.statusFilter) result = result.filter(n => String(n.notification_checked).includes(this.statusFilter));

		// 	this.list = result;
		// },

		// /**
		//  * Update a notification
		//  * @param {Object} item - all informations of this notification
		//  */
		// async updateNotification(item){
		// 	/*
		// 	 * //console.log("updateNotification", this.isInputRequired(item.notification_type_id) == 1, item.notification_checked == 0, item.additional_field == "");
		// 	 * if(this.isInputRequired(item.notification_type_id) == 1 && item.notification_checked == 0 && !item.additional_field){
		// 	 * 	this.$vs.notify({
		// 	 * 		title: "Echec",
		// 	 * 		text: "Veuillez remplir le champ additionnel pour valider l'alerte."
		// 	 * 	});
		// 	 * 	return false;
		// 	 * }
		// 	 */
		// 	item.notification_checked = item.notification_checked == 1 ? 0 : 1;
		// 	await this.$http.post(this.apiUrl + "notifications/commercial/update", {
		// 		commercial_notification: {
		// 			id: item.id,
		// 			society_id: item.society_id,
		// 			contract_id: item.contract_id,
		// 			mission_id: item.mission_id,
		// 			commercial_id: item.commercial_id,
		// 			engagement_duration: item.engagement_duration,
		// 			early_cancellation_duration: item.early_cancellation_duration,
		// 			missions_start_period: item.missions_start_period ? item.missions_start_period.replace(/T|Z/g, " ") : null,
		// 			estimated_end_date: item.estimated_end_date ? item.estimated_end_date.replace(/T|Z/g, " ") : null,
		// 			notification_type_id: item.notification_type_id,
		// 			notification_checked: item.notification_checked,
		// 			additional_field: item.additional_field
		// 		}
		// 	}).then(res => {
		// 		// //console.log("Update notification:", res.data);
		// 		let commentary = item.notification_checked == 0 ? "Relance: de 'Traitée' à 'A traitée'" : "Relance: de 'A traitée' à 'Traitée'";

		// 		this.$http.post(this.apiUrl + "logger/contract/add/" + item.contract_id, {
		// 			action_id: 1,
		// 			mission_id: item.mission_id,
		// 			users_id: this.activeUser.id,
		// 			comment: item.additional_field ? `${commentary} : ${item.additional_field}` : commentary
		// 		}).then(() => {
		// 			this.$vs.notify({
		// 				title: "Succès",
		// 				text: "Relance mise à jour."
		// 			});
		// 			this.$emit("refresh-counter");
		// 			// //console.log("Update notification:", res.data);
		// 		});
		// 	});
		// },
	},
};
</script>

<style>
</style>
